import { Project } from "@snubes/snubes-types";
import { DateTime } from "luxon";
import { getProjectReportFramesFromLastSevenDays } from "./getProjectReportFramesFromLastSevenDays";

export function getProjectAverageHandlingTimeInSeconds(project: Project) {
  const now = DateTime.now().toISODate();
  const today =
    project.reportFramesByDay?.find((r) => r.id === now)
      ?.averageHandlingTimeInSeconds || 0;
  const frames = getProjectReportFramesFromLastSevenDays(project);
  const totalCallsCount = frames.reduce(
    (result, frame) => result + frame.totalCallsCount,
    0,
  );
  const lastSevenDays = totalCallsCount
    ? frames.reduce(
        (result, frame) =>
          result + frame.averageHandlingTimeInSeconds * frame.totalCallsCount,
        0,
      ) / totalCallsCount
    : 0;

  return { today, lastSevenDays };
}
